export default{
  version_1: "v1.0.0", 
  version_2: "v2.0.0",
  authPrefix: "auth",// '/login','/logout','/getInfo','/captchaImage' 登录，退出登录，获取用户信息,获取图片验证码这四个接口前缀特殊处理
  sysPrefix: "system",//系统接口前缀
  unpaidWagesPrefix: "backpay",//工地欠薪接口前缀
  businessPrefix: "industrialInjury",//标准地址接口前缀
  policyPrefix: "policy",//政策接口前缀
  cultivatePrefix: "cultivate",//培训接口前缀
  employmentPrefix: "job",//就业接口前缀
  cryptoKey:'1qaz2wsx3edc4rfv',//接口加密密钥
  showOriginParam:true,//展示原始传参 加密之前的
}